@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@radio-button-diameter: 16px;
@radio-button-border-width: 1px;
@half-radio-button-diameter: calc(@radio-button-diameter / 2);
@radio-button-spacing: calc(((@radio-button-diameter - (2 * @radio-button-border-width)) - @half-radio-button-diameter) / 2);

.radio-check-button {
  display: block;
  position: relative;
  padding: 10px 0;
  font-size: 14px;
  user-select: none;

  &.disabled {
    input {
      cursor: default;
    }
  }

  label {
    cursor: pointer;

    &.disabled {
      color: @radio-check-list--radio-check-button--disabled--text-color;
      cursor: default;
    }
  }

  input {
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }
}

.radio-check-button-content {
  display: flex;
  align-items: center;
}

.radio-button {
  height: @radio-button-diameter;
  min-width: @radio-button-diameter;
  background-color: @radio-check-list--radio-button--background-color;
  border: @radio-button-border-width solid @radio-check-list--radio-button--border-color;
  border-radius: @half-radio-button-diameter;
  margin-right: @half-radio-button-diameter;

  &:hover {
    background-color: @radio-check-list--radio-button--hover--background-color;
  }

  &.checked {
    &:after {
      display: block;
    }
  }

  &.disabled {
    background-color: var(--radio-check-list--radio-button--disabled--background-color);
    border: @radio-button-border-width solid var(--radio-check-list--radio-button--disabled--border-color);

    &.checked {
      border-color: var(--radio-check-list--radio-button--disabled--checked--border-color);
    }

    &:after {
      background-color: var(--radio-check-list--radio-button--indicator--disabled--background-color);
    }
  }

  &:after {
    content: '';
    position: relative;
    display: none;
    top: @radio-button-spacing;
    left: @radio-button-spacing;
    width: @half-radio-button-diameter;
    height: @half-radio-button-diameter;
    border-radius: calc(@half-radio-button-diameter / 2);
    background: var(--radio-check-list--radio-button--indicator--background-color);
  }
}
